import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSettings,
  updateSettings,
  setCurrentBankOrLut,
} from "./thunk";

interface SettingsState {
  settings: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  settings: null,
  loading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed to fetch settings";
      })
      .addCase(updateSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(updateSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed to update settings";
      })
      .addCase(setCurrentBankOrLut.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(setCurrentBankOrLut.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(setCurrentBankOrLut.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed to set current";
      });
  },
});

export default settingsSlice.reducer;
